import { Form } from '@mairistem/composants';
import dayjs from 'dayjs';

import { formatMonetaire } from '@/utils';

interface PaiementEnLigneProps {
  /** Libellé du mode : « Carte bancaire par internet » ou « Prélèvement par internet ». */
  libelle: string;
  /** Référence PayFiP de la transaction, portée par le règlement. */
  numero?: string | null;
  /** Date et heure du paiement sur la plateforme, portées par le reçu et non par le règlement. */
  datePaiement?: string | null;
  montant: number;
}

/**
 * Règlement d'un paiement fait en ligne sur Mon Espace Famille (CBI ou PRI), redescendu de MFO.
 * Il n'est jamais saisi au guichet : on n'en affiche que le mode, la référence PayFiP, la date du
 * paiement et le montant.
 */
const PaiementEnLigne = (props: PaiementEnLigneProps) => {
  const {
    libelle: libelleProps,
    numero: numeroProps,
    datePaiement: datePaiementProps,
    montant: montantProps,
  } = props;

  return (
    <Form.Group style={{ margin: 0, flex: 1 }}>
      <Form.Field inline width={4}>
        <label>{libelleProps}</label>
      </Form.Field>
      <Form.Field inline width={4}>
        Référence PayFiP
        {' : '}
        <label>{numeroProps}</label>
      </Form.Field>
      <Form.Field inline width={4}>
        {datePaiementProps && (
          <>
            Payé le <label>{dayjs(datePaiementProps).format('DD/MM/YYYY [à] HH:mm')}</label>
          </>
        )}
      </Form.Field>
      <Form.Field
        inline
        width={4}
        // @ts-expect-error
        style={{ textAlign: 'right' }}
      >
        Montant
        {' : '}
        <label>{formatMonetaire(montantProps, 2)}</label>
      </Form.Field>
    </Form.Group>
  );
};

export default PaiementEnLigne;
